import * as opfs_utils from '@/ts/utils/opfs';

export default class Photo {

  public private: boolean;
  public image_thumb_cache: string = '';
  public image_fullhd_cache: string = '';

  public asyncRequestFullHD = false;
  public asyncRequestThumb = false;

  constructor(public id: number, public name: string, public description: string, public org_filename: string, public exif_time_taken: any, public image: string, public image_fullhd: string, public image_thumb: string, priv: boolean, order: number, past: boolean) {
    this.private = priv;
  }



  // Thumb cache

  public get_image_thumb() {
    if (this.image_thumb_cache) {
      return this.image_thumb_cache;
    } else {
      if (! this.asyncRequestThumb) {
        this.asyncRequestThumb = true;
        this.generate_image_thumb_cache();
      }
      return '';
    }
  }

  public async generate_image_thumb_cache() {
    await opfs_utils.openDirectory();
    const fileName = this.image_thumb.replaceAll('/', "_").replaceAll(":", "_");
    const fileUrl = await opfs_utils.getFileUrl(fileName);
    if (fileUrl) {
      this.image_thumb_cache = fileUrl;
    } else {
      this.image_thumb_cache = this.image_thumb;
    }
  }



  // FullHD cache

  public get_image_fullhd() {
    if (this.image_fullhd_cache) {
      return this.image_fullhd_cache;
    } else {
      if (! this.asyncRequestFullHD) {
        this.asyncRequestFullHD = true;
        this.generate_image_fullhd_cache();
      }
      return '';
    }
  }

  public async generate_image_fullhd_cache() {
    await opfs_utils.openDirectory();
    const fileName = this.image_fullhd.replaceAll('/', "_").replaceAll(":", "_");
    const fileUrl = await opfs_utils.getFileUrl(fileName);
    if (fileUrl) {
      this.image_fullhd_cache = fileUrl;
    } else {
      this.image_fullhd_cache = this.image_fullhd;
    }
  }

}
